import { mapEnum } from 'Commons/helpers/utils/Formatter';

const OVERLOCK_UNLOCK_PENDING_STATUS = mapEnum(['Unlock_Pending', 'Overlock_Pending']);

export default OVERLOCK_UNLOCK_PENDING_STATUS;
